import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_Get_Public_Communities = Array<{
  id: number;
  name: string;
  description: string;
  is_active: boolean;
  require_verification: boolean;
  created_at: string;
  member_count: number;
  user_membership_status: 'PENDING' | null;
  user_membership_id: number | null;
}>;

const METHOD = 'GET';
const ENDPOINT = 'communities/public';

export const QUERY_KEY = () =>
  getQueryKey(
    METHOD,
    getResolvedEndpoint(ENDPOINT, {}),
    {}
  );

export const useGetPublicCommunities = (enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(),
    queryFn: async () => {
      const data = await handleApiCall<
        ApiResponse_Get_Public_Communities,
        Record<string, never>
      >(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        {}
      );

      return data;
    },
  });
};